<template>
  <div>
    <div class="wall-head">商品管理</div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="130px" class="mt-35">
      <div class="wall p-30">
        <div style="max-width: 1024px;">
          <el-form-item label="分类" prop="category_id" :error="(error.category_id || [])[0]">
            <el-cascader
              v-loading="loadingCate"
              element-loading-spinner="el-icon-loading"
              style="width: 320px"
              v-model="category"
              :options="categories"
              @change="handleChangeCate"
              filterable
              :props="{
                value: 'id',
                label: 'name',
                children: 'sub_cat'
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item
            label="品牌"
            prop="brand_id"
            :error="(error.brand_id || [])[0]"
          >
            <el-select
              element-loading-spinner="el-icon-loading"
              v-loading="brandLoading"
              v-if="renderBrandSelect"
              v-model="formData.brand_id"
              no-data-text="请先选择分类"
              style="width: 320px"
              filterable
              placeholder="请选择品牌">
              <el-option
                v-for="(item, index) in brandList"
                :key="index"
                :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="第三方平台链接" prop="compare_url" :error="(error.compare_url || [])[0]">
            <el-input v-model="formData.compare_url"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="title" :error="(error.title || [])[0]">
            <el-input v-model="formData.title" maxlength="60" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="副标题" prop="sub_title" :error="(error.sub_title || [])[0]">
            <el-input v-model="formData.sub_title" maxlength="80" show-word-limit></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="wall mt-20" id="productSkus">
        <div style="max-width: 1024px;">
          <sku-item :defaultSkus="formData.skus" ref="skus" :error="error.skus || []"/>
        </div>
          <el-form-item label="市场价" prop="market_price" :error="(error.market_price || [])[0]" required>
            <el-input v-model.number="formData.market_price" type="number" style="width: 220px" placeholder="商品一口价或建议零售价"></el-input>
          </el-form-item>
      </div>

      <div class="wall mt-20">

        <div style="max-width: 1024px;">
          <el-form-item label="商品图片" prop="picture" :error="(error.picture || error.banner || [])[0]">
            <div class="d-flex image-item">
              <uploader class="mb-20" v-model="formData.picture" :notice="'商品主图'"/>
              <uploader
                v-for="(imgItem, index) in formData.banner"
                :key="index"
                v-model="formData.banner[index]"
                :remove="true"
                @no-remove="handleRemoveBannerImage(index)"
                @prev="handlePrevImage(index)"
                @next="handleNextImage(index)"
                :prev="showPrevIcon(index)"
                :next="showNextIcon(index)"
                class="mb-20"
              />
              <uploader @on-change="addBanner" v-if="formData.banner.length < 6" />
            </div>
          </el-form-item>

          <el-form-item label="商品详情页" class="form-editor" prop="detail" :error="(error.detail || [])[0]">
            <!-- <editor v-if="false" v-model="formData.detail" /> -->
            <div style="width: 800px">
              <Tinymce :height=400 ref="editor" v-model="formData.detail"></Tinymce>
            </div>
          </el-form-item>

          <el-form-item label="发货模版">
            <el-select v-model="formData.delivery_area_id" placeholder="请选择">
              <el-option label="全国" :value="null" />
              <el-option
                v-for="item in deliveries"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <router-link class="ml-10 color-primary" to="/management/shipping">管理模版</router-link>
          </el-form-item>

          <!-- <el-form-item label="上架" required>
            <el-radio-group v-model="formData.status">
              <el-radio label="check">立即上架</el-radio>
              <el-radio label="off">放入仓库</el-radio>
            </el-radio-group>
          </el-form-item> -->

          <el-form-item>
            <el-button
              type="primary"
              class="btn-primary-orange"
              round
              size="small"
              :loading="submitLoading"
              @click="handleSubmit"
            >提 交</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getProduct, getCategories, createProduct, updateProduct, getBrandList } from '@/api/product.js';
import { getDeliveries } from '@/api/area';
import Uploader from '@/components/Uploader.vue';
import { deepClone } from '@/utils';
// import Editor from '@/components/Editor.vue';
import SkuItem from './components/SkuItem.vue';
import rules from './components/rules';
import Tinymce from '@/components/Tinymce'
export default {
  components: {
    Tinymce,
    Uploader,
    // Editor,
    SkuItem
  },
  data() {
    return {
      submitLoading: false,
      brandLoading: false,
      categories: [], // 分类列表
      brandList: [], // 品牌列表
      deliveries: [], // 发货模板
      loadingCate: false, // 分类加载动画
      renderBrandSelect: true, // 是否渲染品牌选择框
      formData: {
        category_id: null,
        brand_id: '',
        compare_url: '',
        title: '',
        sub_title: '',
        picture: '',
        delivery_area_id: null,
        skus: [
          {
            title: '',
            picture: '',
            price: 0,
            code: '',
            stock: 0,
            specs: {
              "颜色": '红色'
            }
          }
        ],
        banner: [],
        detail: '',
        status: 'check',
        market_price: null
      },
      currentBrandCategory: 0,
      category: [0, 0, 0], // 当前分类选择框绑定的数据
      tmpCategory: [0, 0, 0], // 临时分类数据，用户在处理数据的时候临时存放分类信息。
      rules: rules, // 表单验证规则
      error: {} // API错误信息
    }
  },
  created() {
    this.getCategories();
    let productId = this.$route.query.id || 0;
    if (productId) {
      this.loadlProduct(productId);
    }
    getDeliveries().then(res => {
      this.deliveries = res.results || []
    })
  },
  methods: {
    // 获取所有的分类信息
    async getCategories() {
      this.loadingCate = true;
      let { results } = await getCategories();
      this.loadingCate = false;
      this.categories = results;
      // 更新级联选择器
      this.buildNewCategoryArray(this.categories);
      this.category = this.tmpCategory
    },
    // 加载品牌信息
    async loadBrandList() {
      this.brandLoading = true;
      this.brandList = await getBrandList({
        category_id: this.currentBrandCategory,
        offset: 0,
        limit: 300,
      }) || [];

      // 便利数据，不包含当前选择的品牌信息时清空品牌信息
      let needClear = true;
      for (let i = 0; i < this.brandList.length; i ++) {
        if (this.brandList[i].id === this.formData.brand_id) {
          needClear = false;
          break;
        }
      }
      if (needClear) this.formData.brand_id = null;

      // this.brandList = results;
      // 此时需要重新渲染品牌框，防止旧数据干扰
      this.renderBrandSelect = false;
      this.$nextTick(() => {
        this.brandLoading = false;
        this.renderBrandSelect = true;
      });
      
    },
    // 遍历分类信息，根据返回的三级分类ID匹配对应的一级二级ID。
    // 并将数据组合成长度为三的数组，用户级联选择器的数据绑定使用。
    // cates： 当前层级的分类信息
    // index： 分类数组索引
    buildNewCategoryArray(cates, index = 0) {
      // 没有分类ID，跳过。
      if (!this.formData.category_id) return false;

      // 遍历当前层级分类
      for (let indexOne = 0; indexOne < cates.length; indexOne++) {
        // 直接替换当前层级对应分类数组的索引位置，直到子或者孙层分类匹配当前分类时停止。
        // 这里会使用一个临时分类变量，因为会在递归过程中不断修改当前递归层级对应分类数组索引位置的值
        // 防止因在这里修改的时候触发变更监听函数，造成数据紊乱。
        this.tmpCategory.splice(index, 1, cates[indexOne].id);
        // 如果存在子分类，则接着搜索子分类，并在子分类返回 false，即查找到数据时停止。
        if (cates[indexOne].sub_cat) {
          let next = this.buildNewCategoryArray(cates[indexOne].sub_cat, index+1);
          if (!next) return false;
        }
        // 查找到对应ID的分类，返回false，告知上层递归函数停止搜索
        if (cates[indexOne].id === this.formData.category_id) {
          return false;
        }
      }
      // 没有查找到数据时，返回true，上层递归函数会继续索引。
      return true;
    },
    // 获取指定的商品信息
    loadlProduct(id) {
      getProduct(id).then(res => {
        this.formData = Object.assign(this.formData, res);
        if (this.formData.status == 'on') this.formData.status = 'check';
        this.buildNewCategoryArray(this.categories);
        this.category = this.tmpCategory;
        setTimeout(() => {
          let _currentBrandCategory = this.category.slice(-2, -1)[0]
          if (_currentBrandCategory !== this.currentBrandCategory) {
            this.currentBrandCategory = _currentBrandCategory;
            this.loadBrandList();
          }
        }, 500);
      }).catch(() => {
        this.$route.go(-1);
      })
    },
    // 监听分类变更。
    // 这里需要情况品牌id，否则在无品牌匹配的情况下，会有显示问题。
    handleChangeCate(v) {
      this.formData.category_id = v.slice(-1)[0];
      // this.formData.brand_id = null;
      let _currentBrandCategory = v.slice(-2, -1)[0];
      if (_currentBrandCategory !== this.currentBrandCategory) {
        this.currentBrandCategory = _currentBrandCategory;
        this.loadBrandList();
      }
    },
    // 新增banner图片
    addBanner(file) {
      this.formData.banner.push(file);
    },
    // 移除banner图片
    handleRemoveBannerImage(index) {
      this.formData.banner.splice(index, 1);
    },
    handlePrevImage(index) {
      let temp1 = this.formData.banner[index];
      let temp2 = this.formData.banner[index - 1];
      this.formData.banner.splice(index - 1, 2, temp1, temp2);
    },
    showPrevIcon(index) {
      return index > 0
    },
    showNextIcon(index) {
      return index < this.formData.banner.length-1
    },
    handleNextImage(index) {
      let temp1 = this.formData.banner[index + 1];
      let temp2 = this.formData.banner[index];
      this.formData.banner.splice(index, 2, temp1, temp2);
    },
    // 监听提交按钮
    handleSubmit(e) {
      e.preventDefault();
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submitData();
        } else {
          document.getElementById("app").scrollIntoView();
          this.$message.error('请补充必填信息');
          return false;
        }
      });
    },
    submitData() {
      let _data = Object.assign(
        deepClone(this.formData),
        { skus: this.$refs.skus.skuValues});

      // 重新生成市场价和优惠价
      // 用最少的市场价和优惠价
      let _market_price = 0;
      let _shop_price = 9999999;
      let _welfare = 0;
      let _skuPass = true; // sku默认验证状态
      let _stock = 0;
      let _error = '请补充完整SKU信息';
      
      console.log(_data.skus)

      _data.skus.forEach(item => {
        Object.keys(item.specs).forEach(k => {
          if (item.specs[k] === null || item.specs[k] === '') {
            _skuPass = false;
            _error = `商品规格"${k}"不能为空`;
          }
        })

        _stock += item.stock;
        // 取最高价格为市场价，已备用户在未填写价格的时候使用
        if (Number(item.shop_price) > _market_price) _market_price = item.shop_price;
        // if (Number(item.shop_price) < _shop_price) _shop_price = item.shop_price;
        if (!item.shop_price) _skuPass = false;
        if (item.stock < 0) {
          _skuPass = false;
          _error = '库存不能小于0';
        }
        // 检测福利券金额，少于指定值的自定设置
        // let _minWelfare = Math.ceil(item.shop_price * 10/ 100) ;
        // if (item.welfare < _minWelfare) item.welfare = _minWelfare;
        if (item.welfare > item.shop_price) item.welfare = Math.floor(item.shop_price);
        if (item.welfare > _welfare) {
          _welfare = item.welfare;
          _shop_price = item.shop_price;
        }
      })

      if (!_skuPass) {
        document.getElementById("productSkus").scrollIntoView();
        this.$message.error(_error);
        return false;
      }

      if (!_data.market_price) {
        _data.market_price = _market_price;
      }
      _data.shop_price = _shop_price;
      _data.welfare =_welfare
      _data.stock = _stock;
      // 手动移除富文本自带属性
      // _data.detail = _data.detail.replace(/style="[^"]*?"/g, '');
      _data.detail = _data.detail.replace(/data-mce-src="[^"]*?"/g, '');

      this.submitLoading = true
      this.sendData(_data).then(() => {
        this.$message.success(this.formData.id ? '商品编辑成功' : '商品添加成功');
        setTimeout(() => {
          this.$router.go(-1);
        }, 500);
      }).catch(err => {
        this.submitLoading = false
        this.error = err.data || {}
      });
    },
    // 发送数据
    sendData(_data) {
      if (this.formData.id) {
        return updateProduct(this.formData.id, _data)
      } else {
        return createProduct(_data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-item {
  flex-wrap: wrap;
}
</style>

